// extracted by mini-css-extract-plugin
export default {"post":"Post_post__s-zpv"};